import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Autocomplete, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * Header ContasReceber Lista.
 * 
 */

type Props = {
  ddlBancoPagamento: DropDown[];
  selectedIdsBancoPagamento?: number[];
  status?: number | null;

  onClearFilters: () => void;
  handleIdsBancoPagamentoChange: (v: number[]) => void;
  onStatusChange: (novoStatus: number) => void;
};


export const Header = ({
  ddlBancoPagamento,
  selectedIdsBancoPagamento,
  status,
  onClearFilters,
  onStatusChange,
  handleIdsBancoPagamentoChange,

}: Props) => {
  const minValidYear = 1900;

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Banco'
                  value={ddlBancoPagamento.filter(x => selectedIdsBancoPagamento?.includes(x.id))}
                  options={ddlBancoPagamento}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsBancoPagamentoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <FormControl size="small" fullWidth>
                  <InputLabel id="modulo-dashboard"></InputLabel>
                  <Select
                    labelId="modulo-dashboard"
                    value={status ?? 2}
                    onChange={handleStatusChange}>
                    <MenuItem value={2}>Todos </MenuItem>
                    <MenuItem value={0}>Inativos</MenuItem>
                    <MenuItem value={1}>Ativos</MenuItem>

                  </Select>
                </FormControl>

              </div>
            </div>


            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
              <div className="w-[180px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                  buttonColor="yellow"
                  onClick={handleClearFilters}>
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>

          </div>
        </div>

      </CascateList>
    </>
  );
}